// Submits the MFA form as soon as a 6-digit code is typed or pasted.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code"]

  connect() {
    this.submitted = false
    // Covers a code that the browser filled in before this controller connected.
    this.changed()
  }

  changed() {
    if (this.submitted) return

    const digitsOnly = this.codeTarget.value.replace(/\D/g, "").slice(0, 6)
    if (this.codeTarget.value !== digitsOnly) {
      this.codeTarget.value = digitsOnly
    }

    if (digitsOnly.length === 6) {
      this.element.requestSubmit()
    }
  }

  // The 6th digit and the Enter key can both try to submit. Only the first one should go through,
  // because a second request would consume the code and then fail.
  guard(event) {
    if (this.submitted) {
      event.preventDefault()
      return
    }

    this.submitted = true
    this.codeTarget.readOnly = true
  }
}
